import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgProcessor = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M14 10H10V14H14V10Z",
		fill: "#111111"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M15 4H17V6L17.5 6.5L18 7H20V9H18V11H20V13H18V15H20V17H18L17.5 17.5L17 18V20H15V18H13V20H11V18H9V20H7V18L6.5 17.5L6 17H4V15H6V13H4V11H6V9H4V7H6L6.5 6.5L7 6V4H9V6H11V4H13V6H15V4ZM8 8H16V16H8V8Z",
		fill: "#111111"
	})]
});
export default SvgProcessor;
